import React, { useState } from 'react';
import ChiTietHopDong from "service/chiTietHopDongApi";
import ChiTietHopDongContainer from 'containers/Common/QuanLyChoVay/ChiTietHopDongContainerV2';

export const BtnChiTietHopDong = ({ item }) => {
    const [showChiTietHopDong, setShowChiTietHopDong] = useState(false);
    const handleShowChiTietHopDong = () => setShowChiTietHopDong(true);
    const objChiTietHopDong = {};
    const [chovayChiTiet, setChoVay] = useState(objChiTietHopDong);
    const timkiemHopDong = { ChoVayId: 0 };
    const displayCode = item.ContractCode ?? item.MaHopDong;
    const contractId = item.ChoVayId ?? item.ChoVayID;
    const functionChiTietChoVay = () => {
        console.log(timkiemHopDong);
        timkiemHopDong.ChoVayId = contractId;
        ChiTietHopDong.getChiTietHopDong1(contractId).then((response) => {
            setChoVay(response.data);
            setShowChiTietHopDong(true);
        });
    };
    return (
        <>
            <a href="#!" onClick={functionChiTietChoVay} className="blue btn-link">{displayCode}</a>
            {showChiTietHopDong && (
                <ChiTietHopDongContainer
                    show={handleShowChiTietHopDong}
                    onHide={() => setShowChiTietHopDong(false)}
                    data={chovayChiTiet}
                    setModalTaiSan={handleShowChiTietHopDong}
                />
            )}
        </>
    );
};